var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKioskinline = function SvgKioskinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 11.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kiosk_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E1F27",
    d: "M18.543 27.332a8.543 8.543 0 1 0 8.543 8.543 8.552 8.552 0 0 0-8.543-8.543Zm0 16.031a7.488 7.488 0 1 1 7.488-7.488 7.497 7.497 0 0 1-7.488 7.488Zm3.129-7.705a.528.528 0 0 0 .527-.528v-2.812a.527.527 0 1 0-1.055 0v2.812a.528.528 0 0 0 .528.528Zm9.457-15.75a.527.527 0 0 0 .527-.528v-2.812a.527.527 0 0 0-1.054 0v2.812a.528.528 0 0 0 .527.528Zm-8.72 18.92h-7.731a.527.527 0 1 0 0 1.054h7.73a.527.527 0 0 0 0-1.055Zm-6.995-3.17a.528.528 0 0 0 .527-.528v-2.812a.527.527 0 1 0-1.054 0v2.812a.528.528 0 0 0 .527.528Zm18.914 0a.527.527 0 0 0 .527-.528v-2.812a.527.527 0 0 0-1.054 0v2.812a.528.528 0 0 0 .527.528Zm3.129 1.943a5.74 5.74 0 0 0-4.257 1.898.525.525 0 0 0 .216.85.526.526 0 0 0 .568-.144 4.67 4.67 0 0 1 6.946 0 .527.527 0 1 0 .784-.706 5.742 5.742 0 0 0-4.257-1.898Zm0-10.269A8.543 8.543 0 1 0 46 35.875a8.553 8.553 0 0 0-8.543-8.543Zm0 16.031a7.488 7.488 0 1 1 7.488-7.488 7.497 7.497 0 0 1-7.488 7.488ZM24.871 19.908a.527.527 0 0 0 .527-.528v-2.812a.527.527 0 1 0-1.054 0v2.812a.526.526 0 0 0 .527.528Zm15.715 15.75a.528.528 0 0 0 .527-.528v-2.812a.527.527 0 0 0-1.054 0v2.812a.528.528 0 0 0 .527.528Zm-8.368-12.445a.526.526 0 0 0-.745.039 4.669 4.669 0 0 1-6.946 0 .528.528 0 1 0-.784.706 5.722 5.722 0 0 0 8.514 0 .529.529 0 0 0-.039-.745Zm4.325-3.088A8.543 8.543 0 1 0 28 28.668a8.553 8.553 0 0 0 8.543-8.543ZM28 27.613a7.489 7.489 0 1 1 7.488-7.488A7.497 7.497 0 0 1 28 27.613Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#000",
    rx: 11.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kiosk_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 10h36v36H10z"
  })))));
};
export default SvgKioskinline;